<template>
  <div id="park">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <article-detail :article-list-nav="pageData"></article-detail>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import ArticleDetail from '@/components/ArticleDetail.vue'
  import banner from '../assets/images/banner/applyBanner.png'

  export default {
    name: 'ArticleDetailPage',
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ArticleDetail
    },
    data() {
      return {

      }
    },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      }
    },
    created() {
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 // $themeColor: #3e76fc;
  #park {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
  }
</style>
